const getRealOddsProfitCommission = (odds, commissionPercent) => {
  const realOdds = 1 + (odds - 1) * (1 - commissionPercent / 100);
  return parseFloat(realOdds.toFixed(6));
};
const formulaLay = (odd, valuePercent) => {
  let percent = valuePercent * 0.01;
  let partOdd = odd / (odd - 1);
  let realOdd = partOdd * (1 - percent) + percent;
  return parseFloat(realOdd.toFixed(6));
};
function findOpetationFavorValues(dataOperation) {
  let listFavorValues = dataOperation.map((item) => {
    let isLay = item.market_event.toLowerCase().includes("lay (contra)");
    if (isLay) {
      let oddNoChange = item.chance;
      let cashBet = item.stake;
      let favorValue = cashBet / (oddNoChange - 1);
      item.backStake = +favorValue.toFixed(2);
      return item;
    }
    item.backStake = 0;
    return item;
  });
  return listFavorValues;
}
function calcSurebetBonusFromBets(stakeBonus, bets, indexFree, roundTo, roundingEnabled, skipUpateBackStake) {
  const listOdds = bets.map((b) => {
    const isLay = b.market_event.toLowerCase().includes("lay (contra)");
    return isLay ? formulaLay(b.chance, b.commission) : getRealOddsProfitCommission(b.chance, b.commission);
  });
  const grossProfitFreeBet = listOdds[indexFree] * stakeBonus - stakeBonus;
  const listStakes = listOdds.map(
    (odd, index) => {
      if (index === indexFree) {
        return stakeBonus;
      }
      let stake = index === indexFree ? stakeBonus : +(grossProfitFreeBet / odd).toFixed(2);
      if (roundingEnabled) {
        stake = Math.round(stake / roundTo) * roundTo;
      }
      return +stake.toFixed(2);
    }
  );
  let budget = 0;
  for (let i = 0; i < listStakes.length; i++) {
    if (i === indexFree) continue;
    budget += listStakes[i];
  }
  const liquidProfitBonus = grossProfitFreeBet - budget;
  const listProfts = listStakes.map(
    (stake, index) => index === indexFree ? liquidProfitBonus : stake * listOdds[index] - budget
  );
  const surebetCalculated = bets.map((bet, i) => ({
    ...bet,
    stake: listStakes[i],
    profit: +listProfts[i].toFixed(2)
  }));
  if (skipUpateBackStake === false) {
    const bookMakersWithBackStakeChanged = findOpetationFavorValues(surebetCalculated);
    return bookMakersWithBackStakeChanged;
  }
  return surebetCalculated;
}
const calcNormalSurebet = (paramBudget, paramRoundTo, paramRoundingEnabled, paramBookmakers) => {
  const adjustedOdds = paramBookmakers.map((b) => {
    const isLay = b.market_event.toLowerCase().includes("lay (contra)");
    return isLay ? formulaLay(b.chance, b.commission) : getRealOddsProfitCommission(b.chance, b.commission);
  });
  const totalInverseOdds = adjustedOdds.reduce((sum, odd) => sum + 1 / odd, 0);
  let newBookmakers = paramBookmakers.map((b, i) => {
    let stake = paramBudget / adjustedOdds[i] / totalInverseOdds;
    if (paramRoundingEnabled) {
      stake = Math.round(stake / paramRoundTo) * paramRoundTo;
    }
    return { ...b, stake: parseFloat(stake.toFixed(2)) };
  });
  const totalStake = paramRoundingEnabled ? newBookmakers.reduce((sum, b) => sum + b.stake, 0) : paramBudget;
  let sumAllProfit = 0;
  newBookmakers = newBookmakers.map((b, i) => {
    const profit = b.stake * adjustedOdds[i] - totalStake;
    sumAllProfit += profit;
    return { ...b, profit: +profit.toFixed(2) };
  });
  const newProfit = +(sumAllProfit / newBookmakers.length / totalStake * 100).toFixed(2);
  const bookmakersWithBackStakeUpdated = findOpetationFavorValues([...newBookmakers]);
  return { "dataOperation": bookmakersWithBackStakeUpdated, "profit": newProfit };
};
const stakeChanger = (index, value, selectedBookmaker, roundingEnabled, roundTo, dataOperation, canChangeStake = false, skipUpateBackStake = false, backStake = 0) => {
  const updated = [...dataOperation];
  updated[index].stake = value;
  let dataOperationUpdated = [];
  let budgetUpdated = 0;
  let newProfit = 0;
  let canUpdateProfit = false;
  const adjustedOdds = updated.map((b) => {
    const isLay = b.market_event.toLowerCase().includes("lay (contra)");
    return isLay ? formulaLay(b.chance, b.commission) : getRealOddsProfitCommission(b.chance, b.commission);
  });
  if (selectedBookmaker === index || canChangeStake === true) {
    const targetProfit = value * adjustedOdds[index];
    const newBookmakers = updated.map((b, i) => {
      if (i !== index) {
        let stake = targetProfit / adjustedOdds[i];
        if (roundingEnabled) {
          stake = Math.round(stake / roundTo) * roundTo;
        }
        return { ...b, stake: parseFloat(stake.toFixed(2)) };
      }
      return b;
    });
    let sumAllProfit = 0;
    const totalStake = newBookmakers.reduce((sum, b) => sum + b.stake, 0);
    const withProfit = newBookmakers.map((b, i) => {
      const profit = b.stake * adjustedOdds[i] - totalStake;
      sumAllProfit += profit;
      return { ...b, profit: parseFloat(profit.toFixed(2)) };
    });
    if (skipUpateBackStake === false) {
      const bookMakersWithBackStakeChanged = findOpetationFavorValues(withProfit);
      dataOperationUpdated = [...bookMakersWithBackStakeChanged];
    } else {
      withProfit[index].backStake = backStake;
      dataOperationUpdated = [...withProfit];
    }
    newProfit = +(sumAllProfit / newBookmakers.length / totalStake * 100).toFixed(2);
    canUpdateProfit = true;
    budgetUpdated = +totalStake.toFixed(2);
  } else {
    const totalStake = updated.reduce((sum, b) => sum + b.stake, 0);
    const profit = value * adjustedOdds[index] - totalStake;
    updated[index].profit = parseFloat(profit.toFixed(2));
    let dataRight = updated.map((item, indexBookmaker) => {
      item.profit = adjustedOdds[indexBookmaker] * item.stake - totalStake;
      return item;
    });
    if (skipUpateBackStake === false) {
      const bookMakersWithBackStakeChanged = findOpetationFavorValues(dataRight);
      dataOperationUpdated = [...bookMakersWithBackStakeChanged];
    } else {
      dataRight[index].backStake = backStake;
      dataOperationUpdated = [...dataRight];
    }
    budgetUpdated = +totalStake.toFixed(2);
  }
  return { "dataOperation": dataOperationUpdated, "budget": budgetUpdated, "profit": newProfit, "canUpdateProfit": canUpdateProfit };
};
function calcRiskFreeBetting(odd, value, bonusValue, grossPercentage, roundingEnabled, roundTo) {
  let percentageBonus = grossPercentage / 100;
  let bonus = bonusValue * percentageBonus;
  let newStake = 0;
  let valueToDec = bonus / odd;
  newStake = value - valueToDec;
  if (roundingEnabled === true) {
    newStake = Math.round(newStake / roundTo) * roundTo;
  }
  newStake = +newStake.toFixed(2);
  let profit = +(newStake * odd + bonus).toFixed(2);
  return { "stake": newStake, "profit": profit };
}
const riskFreeBettingFormula = (valueStake, dataOperation, roundingEnabled, roundTo, bonusValue, grossPercentage) => {
  let totalStake = dataOperation.reduce((sum, b) => sum + b.stake, 0);
  if (dataOperation.length > 0) {
    let valueReturned = stakeChanger(0, valueStake, 0, false, 0, dataOperation, false, false, 0);
    const updated = [...valueReturned["dataOperation"]];
    const adjustedOperation = updated.map((b, i) => {
      if (i === 0) {
        return b;
      }
      const isLay = b.market_event.toLowerCase().includes("lay (contra)");
      let odd = isLay ? formulaLay(b.chance, b.commission) : getRealOddsProfitCommission(b.chance, b.commission);
      let resultRalcRiskFreeBetting = calcRiskFreeBetting(odd, b.stake, bonusValue, grossPercentage, roundingEnabled, roundTo);
      b.stake = resultRalcRiskFreeBetting["stake"];
      b.profit = resultRalcRiskFreeBetting["profit"];
      return b;
    });
    totalStake = adjustedOperation.reduce((sum, b) => sum + b.stake, 0);
    const operationBackStakeAdjusted = findOpetationFavorValues(adjustedOperation);
    const profitOperationAdjusted = operationBackStakeAdjusted.map((b, i) => {
      if (i === 0) {
        const isLay = b.market_event.toLowerCase().includes("lay (contra)");
        let odd = isLay ? formulaLay(b.chance, b.commission) : getRealOddsProfitCommission(b.chance, b.commission);
        b.profit = +(odd * b.stake - totalStake).toFixed(2);
        return b;
      }
      b.profit = +(b.profit - totalStake).toFixed(2);
      return b;
    });
    return { "dataOperation": profitOperationAdjusted, "budget": +totalStake.toFixed(2) };
  }
  return { "dataOperation": dataOperation, "budget": +totalStake.toFixed(2) };
};
function surebetLockedValueFormula(lockedValue, dataOperation, roundingEnabled, roundTo) {
  const oldDataOperation = [...dataOperation];
  if (oldDataOperation.length >= 2) {
    const adjustedOdds = oldDataOperation.map((b) => {
      const isLay = b.market_event.toLowerCase().includes("lay (contra)");
      return isLay ? formulaLay(b.chance, b.commission) : getRealOddsProfitCommission(b.chance, b.commission);
    });
    const bookmaker1 = { odd: adjustedOdds[0], impliedProb: 0 };
    const bookmaker2 = { odd: adjustedOdds[1], impliedProb: 0 };
    bookmaker1.impliedProb = 1 / bookmaker1.odd;
    bookmaker2.impliedProb = 1 / bookmaker2.odd;
    const totalImpliedProb = bookmaker1.impliedProb + bookmaker2.impliedProb;
    let newStake = bookmaker1.impliedProb / totalImpliedProb * lockedValue;
    if (roundingEnabled === true) {
      newStake = Math.round(newStake / roundTo) * roundTo;
    }
    newStake = +newStake.toFixed(2);
    let valueReturned = stakeChanger(0, newStake, 0, roundingEnabled, roundTo, oldDataOperation, false, false, 0);
    return valueReturned;
  }
  const totalStake = oldDataOperation.reduce((sum, b) => sum + b.stake, 0);
  let budgetUpdated = +totalStake.toFixed(2);
  return { "dataOperation": dataOperation, "budget": budgetUpdated, "profit": 0, "canUpdateProfit": false };
}
export {
  calcNormalSurebet,
  calcSurebetBonusFromBets,
  findOpetationFavorValues,
  formulaLay,
  getRealOddsProfitCommission,
  riskFreeBettingFormula,
  stakeChanger,
  surebetLockedValueFormula
};